import { ShopperCustomersTypes } from 'commerce-sdk-isomorphic'
export interface CheckoutBrainTreePayload {
  dwfrm_billing_save: boolean
  dwfrm_billing_addressList: string
  dwfrm_billing_billingAddress_addressFields_title: ShopperCustomersTypes.CustomerAddress['title']
  dwfrm_billing_billingAddress_addressFields_firstName: ShopperCustomersTypes.CustomerAddress['firstName']
  dwfrm_billing_billingAddress_addressFields_lastName: ShopperCustomersTypes.CustomerAddress['lastName']
  dwfrm_billing_billingAddress_addressFields_customerAddressID: string
  dwfrm_billing_billingAddress_addressFields_postal: ShopperCustomersTypes.CustomerAddress['postalCode']
  dwfrm_billing_billingAddress_addressFields_address1: ShopperCustomersTypes.CustomerAddress['address1']
  dwfrm_billing_billingAddress_addressFields_address2: ShopperCustomersTypes.CustomerAddress['address2']
  dwfrm_billing_billingAddress_addressFields_city: ShopperCustomersTypes.CustomerAddress['city']
  dwfrm_billing_billingAddress_addressFields_county: ShopperCustomersTypes.CustomerAddress['stateCode']
  dwfrm_billing_billingAddress_addressFields_country: 'gb'
  dwfrm_billing_billingAddress_addressFields_phone: ShopperCustomersTypes.CustomerAddress['phone']
  dwfrm_billing_billingAddress_email_emailAddress: string
  dwfrm_billing_paymentMethods_selectedPaymentMethodID: string
  dwfrm_billing_paymentMethods_creditCardList: string
  dwfrm_creditcard_owner: string
  dwfrm_creditcard_type: string
  dwfrm_creditcard_number: string
  braintreePaymentMethodNonce: string
  braintreePaypalNonce: string
  braintreeDeviceData?: object
  dwfrm_billing_paymentMethods_creditCard_type: string
  dwfrm_billing_paymentMethods_creditCard_number: string
  dwfrm_billing_paymentMethods_creditCard_owner: string
  'cc-expiration-date': string
  dwfrm_billing_paymentMethods_creditCard_expiration_month: string
  dwfrm_billing_paymentMethods_creditCard_expiration_year: string
  dwfrm_billing_paymentMethods_creditCard_cvn: string
}
export interface CheckoutBonusCardStatus {
  hidePayment?: boolean
  bonusCardUsed?: boolean
  leftToPay?: number
  leftToPayHtml?: string
  isServiceActive?: boolean
}
export type CustomSitePreferenceId =
  | 'orderEditModeDurationInMinutes'
  | 'deliveryEditOrderExpirationTime'
  | 'deliveryEditOrderMaxDaysAfterAuth'
  | 'currentOrdersPeriod'
  | 'numberOfStops'
  | 'showMapMinutesAfterDeliverySlotEnd'
  | 'showMapMinutesBeforeDeliverySlotStart'
  | 'disableOrderEditOnSameDay'
  | 'BRAINTREE_APPLEPAY_MERCHANT_LABEL'
  | 'BRAINTREE_Merchant_Account_IDs'
  | 'BRAINTREE_Tokenization_Key'
  | 'BRAINTREE_MAX_saved_card'
  | 'BRAINTREE_savedPaypalCheckoutEnabled'
  | 'BRAINTREE_Vault_Mode'
  | 'BRAINTREE_3DSecure_Enabled'
  | 'BRAINTREE_3DSecure_Skip_Client_Validation_Result'
  | 'disableDefaultPaymentMethods'
  | 'PP_Topup_Enabled'
  | 'BRAINTREE_savedPaypalTopUpEnabled'
  | 'BRAINTREE_PAYPAL_VAULTFLOW'
  | 'BRAINTREE_savedCardEnabled'
  | 'reCaptchaEnable'
  | 'reCaptchaEnableExternal'
  | 'reCaptchaEnableReg'
  | 'reCaptchaEnablePasswordReset'
  | 'reCaptchaEnablePassphrase'
  | 'lazyLoadProductImageUrl'
  | 'baglessEnabled'
  | 'baglessStoresExcluded'
  | 'promoModalPageSize'
  | 'oneTrustEnabled'
  | 'oneTrustId'
  | 'FeefoSupplierMerchantIdentifier'
  | 'showMixandMatchTextOnMultibuyBadge'
  | 'showMultibuyPriceBadge'
  | 'navAppLinkAndroid'
  | 'navAppLinkApple'
  | 'SubstituteToggleEnabled'
  | 'SubstituteToggleMemoryEnabled'
  | 'BRAINTREE_PAYPAL_Billing_Agreement_Description'
  | 'LiveSoftReservationDurationSameDay'
  | 'LiveSoftReservationDurationSameDayEnabled'
  | 'LiveSoftReservationDuration'
  | 'liveChatEnabled'
  | 'liveChatPages'
  | 'SmallBasketChargeEnabled'
  | 'MinOrderValueSameDay'
  | 'isPdpTopRightTileBadgeEnabled'
  | 'isPdpMiddleRightTileBadgeEnabled'
  | 'isPdpBottomRightTileBadgeEnabled'
  | 'deliveryShowSameDayFirst'
  | 'reorderInfoModal'
  | 'bonusCardTopUpMaxValue'
  | 'enableTroubleLoggingInEmail'
  | 'slotNotReleased'
  | 'enableSeasonalOpeningHours'
  | 'seasonalOpeningHoursText'
  | 'allowModifyFirstName'
  | 'allowModifyLastName'
  | 'allowModifyDOB'
  | 'allowModifyContactNumber'
  | 'restrictedProductsJSON'
  | 'selfServeEnabled'
  | 'selfServeNumberOfDaysAfterDelivery'
  | 'selfServeNumberOfHoursAfterDeliverySlot'
  | 'selfServeNumberOfMinutesAfterLastRequest'
  | 'Algolia_UseRegionalIndexes'
  | 'preBookEnabled'
  | 'preBookForNewCustomersEnabled'
  | 'preBookDays'
  | 'preBookSeasonalName'
  | 'deliveryWindowLength'
  | 'hideLeaveProductReviewByGroups'
  | 'retailMediaEnabled'
  | 'klarnaOrderLineName'
  | 'ClearpayOrderLineName'
  | 'ClearpayMerchantName'
  | 'showSlotTimesIn12HourClock'
  | 'ShowReviews'
  | 'enableRapidDelivery'
  | 'rapidDeliverySoftReserveTime'
  | 'rapidDeliveryFallback'
  | 'rapidDeliveryServiceUnavailable'
  | 'rapidDeliveryDeliveryEstimate'
  | 'showSameDayToolTip'
  | 'minimumDeliveryValue'
  | 'rapidDeliveryCustomerGroup'

  export type CustomSitePreferences = Partial<Record<CustomSitePreferenceId, unknown>> & {
  [key: string]: unknown
}
export interface AvailablePaymentMethod {
  id: string
  name: string
  isOrderEditDisabled: boolean
  isTopupDisabled: boolean
  allowPrebook: boolean
  minimumAmount?: {
    amount: number,
    currency: string
  }
  maximumAmount?: {
    amount: number,
    currency: string
  }
}

export interface FilteredPaymentMethod {
  id: string
  name: string
}

export type DeliveryTypes ={
  SAMEDAY: 'Same Day Delivery'
  RAPID: 'Rapid Delivery'
  STANDARD: 'Standard Delivery'
  PREBOOK: 'Pre-Book Delivery'
}

export const DeliveryTypes: DeliveryTypes = {
  SAMEDAY: 'Same Day Delivery',
  RAPID: 'Rapid Delivery',
  STANDARD: 'Standard Delivery',
  PREBOOK: 'Pre-Book Delivery',
} 
